export const all_routes = {
  // dashboard routes
  dealsDashboard: "/dashboard/deals-dashboard",
  leadsDashboard: "/dashboard/leads-dashboard",
  productDashboard: "/dashboard/product-dashboard",
  aiDashboard: "/dashboard/ai-dashboard",

  //crm routes

  
  enrollment: "/crm/enrollment",
  profiling: "/crm/profiling",
  profilingDetails: "/crm/profiling/:id",
  enrollmentDetails: "/crm/enrollment/:id",
  editEnrollmentDetails: "/crm/enrollment/edit/:id",

  deals: "/crm/deals",
  editDealDetails: "/crm/deals/edit/:id",
  dealsDetails: "/crm/deals/:id",

  products: "/crm/products",
  productDetails: "/crm/product/:id",
  editProductDetails: "/crm/product/edit/:id",
  companyDetails: "/crm/company/:id",
  editCompanyDetails: "/crm/company/edit/:id",

  accounts: "/crm/accounts",
  accountGrid: "/crm/account-grid",
  accountDetails: "/crm/accounts/:id",
  companies: "/crm/companies",

  leads: "/crm/leads",
  editLeadDetails: "/crm/leads/edit/:id",
  leadsDetails: "/crm/leads/:id",

  duplicateLeads: "/crm/duplicateLeads",
  editDuplicateLeadDetails: "/crm/duplicateLeads/edit/:id",
  duplicateLeadsDetails: "/crm/duplicateLeads/:id",

  comingSoon: "/coming-soon",

  // auth routes routes
  login: "/",
  register: "/register",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  success: "/success",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",

  // pages routes
  error404: "/error-404",
  error500: "/error-500",
  underMaintenance: "/under-maintenance",

  // reports routes
  companyReports: "/reports/company-reports",
  dealReports: "/reports/deal-reports",
  leadReports: "/reports/lead-reports",
  productReports: "/reports/product-reports",

  // settings routes
  settings: "/crm/settings",
  integrations: "/crm/integrations",
  zoomIntegration: "/crm/integrations/zoom",

  customModule: "/customization/modules",
  fieldPermissions: "/customization/modules/field-permissions",
  fieldListing: "/customization/modules/field-listing",
  moduleFields: "/customization/modules/fields",

  stages: "/crm-settings/stages",

  profile: "/general-settings/profile",
  security: "/general-settings/security",

  //userManagement routes
  deleteRequest: "/user-management/delete-request",
  rolesPermissions: "/user-management/roles-permissions",
  manageusers: "/user-management/manage-users",
  userDetails: "/user-management/manage-users/:id",
  editUserDetails: "/user-management/manage-users/edit/:id",
  permissions: "/user-management/permissions",


  //new profiling form route
  profilingForm: "/public/profiling-form",
};
